import { PARAM_CHANGE } from '@store/actions';
import BLOCKS from '@store/blocks';
import testingAPI from '@utils/testingGUIAPI';
import MAP_CONSTANTS from '@constants/map.json';

export function CROSSHAIR_SETUP(store, index, key, coord) {
    const activeMarker = store.get(BLOCKS.MAP.ACTIVE_MARKERS);
    let markers = [activeMarker[0], activeMarker[1]];

    let coords = { x: markers[index].x, y: markers[index].y };
    let newCoord =  parseInt(coord);
    if (key === 'x' && newCoord >= MAP_CONSTANTS.main.width) {
      newCoord = MAP_CONSTANTS.main.width - 10;
    } else if (key ==='x' && newCoord < 0) {
      newCoord = 0;
    } else if (key === 'y' && newCoord >= MAP_CONSTANTS.main.height) {
      newCoord = MAP_CONSTANTS.main.height - 10;
    } else if (key ==='y' && newCoord < 0) {
      newCoord = 0;
    }
    coords[key] = isNaN(newCoord) ? -1 : newCoord;
    markers[index] = coords;
    PARAM_CHANGE(store, BLOCKS.MAP.ACTIVE_MARKERS, markers);
    if (index === 0) {
      testingAPI.onStartingPointSelect(markers[0].x, markers[0].y);
    } else {
      testingAPI.onEndingPointSelect(markers[1].x, markers[1].y);
    }
    CROSSHAIR_CANCEL(store);
}

export function CROSSHAIR_CANCEL(store) {
  PARAM_CHANGE(store, BLOCKS.MAP.CROSSHAIR_SETTING, -1);
}